import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";

import "./Footer.css";
import { withRouter } from "react-router-dom/cjs/react-router-dom.min";
import axios from "axios";

const Footer = ({ language, location, labels }) => {
  const array = ["Kp", "En", "Cn", "Ru"];

  const { linkLabel, orgTitle, addressLabel, faxLabel, emailLabel, telLabel } =
    labels;

  const [contact, setContact] = useState({
    addressKp: "",
    addressEn: "",
    addressCn: "",
    addressRu: "",

    fax: "",
    tel: "",
    email: "",
  });

  useEffect(() => {
    axios
      .get("/api/home/contact")
      .then((res) => {
        if (res.status == 200 && res.data) setContact(res.data);
      })
      .catch();
  }, []);

  return (
    <footer className="text-white text-center">
      <div className="container">
        <div
          className="row py-4 align-items-center"
          style={{ minHeight: "250px" }}
        >
          <div className="col-sm-12 col-md-6 mt-4 mt-sm-4 mt-md-0">
            {/* <Link to="/"> */}
            <img
              src="./assets/mark2.png"
              alt={"RIPA"}
              style={{ width: "180px", height: "180px" }}
              // onClick={() => {
              //   if (location.pathname === "/")
              //     window.scrollTo({ top: 0, behavior: "smooth" });
              //   else window.scrollTo({ top: 0 });
              // }}
            />
            {/* </Link> */}
          </div>

          <div className="col-sm-12 col-md-6 mt-5 md-sm-5 mt-md-0">
            <div>
              <div className="pb-4 h4 font-weight-bold">
                {linkLabel[language]}
              </div>
              <div className="pb-1 h6">
                {addressLabel[language]}: {contact[`address${array[language]}`]}
              </div>
              {/* <div className="pb-1 h6">
                {faxLabel[language]}: {contact.fax}
              </div> */}
              <div className="pb-1 h6">
                {emailLabel[language]}: {contact.email}
              </div>
              <div className="pb-1 h6">
                {telLabel[language]}:{contact.tel}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        className="container h4 py-4 mb-0 text-center"
        style={{ marginBottom: "0 !important" }}
      >
        <div>{orgTitle[language]}</div>
      </div>
    </footer>
  );
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  language: state.profile.language,
  labels: state.labels,
});

export default connect(mapStateToProps, {})(withRouter(Footer));
